import { Controller } from "@hotwired/stimulus"

// Animates health score numbers and SVG ring fill on the dashboard
export default class extends Controller {
  static targets = ["score", "ring", "bar"]
  static values = {
    score: Number,
    max: { type: Number, default: 900 },
    percentage: Number,
    duration: { type: Number, default: 1200 }
  }

  connect() {
    this.animateAll()
  }

  animateAll() {
    this.scoreTargets.forEach((el) => {
      const target = parseInt(el.dataset.healthScoreTarget === "score" ? this.scoreValue : el.dataset.targetValue, 10)
      this.animateNumber(el, target)
    })

    this.ringTargets.forEach((el) => {
      this.animateRing(el)
    })

    this.barTargets.forEach((el) => {
      this.animateBar(el)
    })
  }

  animateNumber(el, target) {
    const duration = this.durationValue
    const start = performance.now()

    const tick = (now) => {
      const elapsed = now - start
      const progress = Math.min(elapsed / duration, 1)
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3)
      el.textContent = Math.round(eased * target)

      if (progress < 1) {
        requestAnimationFrame(tick)
      }
    }

    requestAnimationFrame(tick)
  }

  animateRing(el) {
    const pct = parseFloat(el.dataset.percentage) || this.percentageValue
    const circumference = parseFloat(el.dataset.circumference)
    const offset = circumference - (pct / 100) * circumference

    el.style.strokeDasharray = `${circumference}`
    el.style.strokeDashoffset = `${circumference}`

    requestAnimationFrame(() => {
      el.style.transition = `stroke-dashoffset ${this.durationValue}ms cubic-bezier(0.4, 0, 0.2, 1)`
      el.style.strokeDashoffset = `${offset}`
    })
  }

  animateBar(el) {
    const pct = parseFloat(el.dataset.percentage) || this.percentageValue
    el.style.width = "0%"

    requestAnimationFrame(() => {
      el.style.transition = `width ${this.durationValue}ms cubic-bezier(0.4, 0, 0.2, 1)`
      el.style.width = `${pct}%`
    })
  }
}
